import { Form, Stack } from "react-bootstrap";

import { useForm } from "../../hooks";
import Select from "../Input/Select";
import TextInput from "../Input/TextInput";
import { states } from "./helpers";
import { UserFormInterface } from "./types";
import StatusMessage from "./StatusMessage";

export default function UserForm({
  buttons,
  mutationResponse,
  onSubmit,
  register,
  user,
}: UserFormInterface) {
  const { form, registerField, validateForm } = useForm(user);
  const { dirty, resetDirty, values } = form;
  const { data, error } = mutationResponse;

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!validateForm()) return false;
    onSubmit(values);
    resetDirty();
  }

  function renderMutationResponse() {
    if (error?.message) return <StatusMessage error message={error.message} />;
    if (data?.success) return <StatusMessage message={data.success} />;
    return null;
  }

  return (
    <Form noValidate onSubmit={handleSubmit}>
      <Stack direction="horizontal" gap={3}>
        <TextInput
          label="First Name"
          {...registerField("first_name", { required: true })}
        />
        <TextInput
          label="Last Name"
          {...registerField("last_name", { required: true })}
        />
      </Stack>
      <TextInput label="Email" {...registerField("email", { email: true })} />
      <Stack direction="horizontal" gap={3}>
        <TextInput
          label="City"
          {...registerField("city", { required: true })}
        />
        <Select
          label="State"
          options={states}
          {...registerField("state", { required: true })}
        />
      </Stack>
      {register && <TextInput label="Registration Code" {...registerField("registration_code", { required: true })} />}

      {renderMutationResponse()}
      <div className="d-flex flex-column align-items-center">
        {buttons(dirty)}
      </div>
    </Form>
  );
}
